import EventTrackingTdvEventsMixin from "./eventTrackingTdvEventsMixin";


/* Creates a new instance of a Brochure Tracking Event to track users events when the user subimits a lead.
 this class contains all the events that needs be to be done.
*/
export default class TourTrackingEvents {
    constructor(model) { 
      const data = {...model, eventLabel: 'Search-Results-Request-Tour'}
      this.events = {};
      this.events.googleAnalytics = [
        new EventTrackingTdvEventsMixin(data)];
    }
  }